(() => {
  const pageType = document.currentScript?.dataset.tbsPageType;
  const key = 'tbs-browsing-v2';
  const resumeParam = 'tbs_resume';
  const read = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(key));
      if (!saved || Date.now() - saved.time > 14400000) return null;
      const url = new URL(saved.url);
      return url.origin === location.origin && !url.pathname.includes('/products/') ? saved : null;
    } catch (_) { return null; }
  };
  const sectionKey = section => section?.id?.split('__').pop() || '';
  const sections = () => Array.from(document.querySelectorAll('[id^="AthenaieProducts-"]'));
  if (pageType === 'product') {
    const saved = read();
    const holder = document.querySelector('[data-tbs-continue-browsing]');
    if (holder && saved && saved.product === location.pathname) {
      const url = new URL(saved.url);
      url.searchParams.set(resumeParam, '1');
      url.searchParams.set('tbs_y', String(Math.round(saved.y)));
      if (saved.anchor) url.hash = saved.anchor;
      holder.querySelector('a').href = url.href;
      holder.hidden = false;
    }
    return;
  }
  if (!['index', 'collection'].includes(pageType)) return;
  const save = link => {
    const anchor = link.closest('[id^="AthenaieProducts-"]') || link.closest('[data-ath-product-item]') || link.closest('[id^="shopify-section-"]');
    const url = new URL(location.href);
    url.searchParams.delete(resumeParam);
    url.searchParams.delete('tbs_y');
    url.hash = '';
    const saved = {
      time: Date.now(), url: url.href, product: new URL(link.href).pathname,
      y: scrollY, anchor: anchor?.id || '', section: sectionKey(anchor),
      productId: anchor?.getAttribute('data-ath-product-id') || '',
      offset: anchor?.getBoundingClientRect().top || 0,
      count: document.querySelectorAll('[data-ath-product-item]:not([hidden])').length,
      carousels: sections().map(section => ({ section: sectionKey(section),
        left: section.querySelector('[data-aie-viewport]')?.scrollLeft || 0 }))
    };
    try { sessionStorage.setItem(key, JSON.stringify(saved)); } catch (_) {}
    history.replaceState({ ...history.state, tbsBrowsing: saved }, '', location.href);
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented || event.button > 0) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname.includes('/products/')) save(link);
  }, true);
  let cleanup = null;
  const restore = event => {
    const url = new URL(location.href);
    const explicit = url.searchParams.get(resumeParam) === '1';
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!explicit && !event?.persisted && navigation?.type !== 'back_forward') return;
    const saved = explicit ? read() : history.state?.tbsBrowsing || read();
    const source = saved && new URL(saved.url);
    if (!saved || source.pathname !== location.pathname) return;
    if (cleanup) cleanup();
    const fallbackY = Number(url.searchParams.get('tbs_y')) || saved.y || 0;
    url.searchParams.delete(resumeParam);
    url.searchParams.delete('tbs_y');
    url.hash = '';
    history.replaceState(history.state, '', url.href);
    const scrollRestoration = history.scrollRestoration;
    history.scrollRestoration = 'manual';
    let cancelled = false;
    let frame = null;
    let observer = null;
    let expiry = null;
    const stop = () => {
      cancelled = true;
      cancelAnimationFrame(frame);
      observer?.disconnect();
      clearTimeout(expiry);
      history.scrollRestoration = scrollRestoration;
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(name => window.removeEventListener(name, stop));
      window.removeEventListener('load', schedule);
      window.removeEventListener('resize', schedule);
    };
    const apply = () => {
      if (cancelled) return;
      sections().forEach(section => {
        const item = saved.carousels.find(item => item.section === sectionKey(section));
        const viewport = section.querySelector('[data-aie-viewport]');
        if (item && viewport && Math.abs(viewport.scrollLeft - item.left) > 1) {
          const behavior = viewport.style.scrollBehavior;
          viewport.style.scrollBehavior = 'auto';
          viewport.scrollLeft = item.left;
          viewport.style.scrollBehavior = behavior;
          viewport.dispatchEvent(new Event('scroll'));
        }
      });
      const anchor = document.getElementById(saved.anchor)
        || sections().find(section => sectionKey(section) === saved.section)
        || (saved.productId ? document.querySelector('[data-ath-product-id="' + saved.productId + '"]') : null);
      const y = anchor ? scrollY + anchor.getBoundingClientRect().top - saved.offset : fallbackY;
      window.scrollTo({ top: Math.max(0, y), behavior: 'instant' });
    };
    function schedule() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(apply);
    }
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(name => window.addEventListener(name, stop, { passive: true }));
    window.addEventListener('load', schedule);
    window.addEventListener('resize', schedule);
    if (typeof ResizeObserver === 'function') {
      observer = new ResizeObserver(schedule);
      observer.observe(document.querySelector('main') || document.body);
      sections().forEach(section => observer.observe(section));
    }
    document.fonts?.ready.then(schedule);
    window.dispatchEvent(new CustomEvent('tbs:restore-browsing', { detail: { count: saved.count } }));
    schedule();
    expiry = setTimeout(stop, 8000);
    cleanup = stop;
  };
  window.addEventListener('pageshow', restore);
  if (document.readyState === 'complete') restore();
})();